export const generateRecaptchaToken = async (siteKey, actionName) =>
  new Promise((resolve, reject) => {
    // Ensure the reCAPTCHA library is fully loaded and ready
    if (!window?.grecaptcha?.enterprise) {
      // Fallback if the script hasn't loaded for some reason
      reject(new Error('reCAPTCHA script not loaded'))
      return
    }

    grecaptcha.enterprise.ready(async () => {
      try {
        // Programmatically execute reCAPTCHA and get the token
        const token = await grecaptcha.enterprise.execute(siteKey, {
          action: actionName,
        })
        resolve(token)
      } catch (error) {
        console.error('reCAPTCHA error:', error)
        reject(error)
      }
    })
  })

export const hideRecaptchaGlobal = () => {
  const styleEl = document.createElement('style')
  styleEl.textContent = '.grecaptcha-badge {visibility: hidden;}'
  document.head.append(styleEl)
}
